import React, { useEffect, useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { GlobalContext } from '../../Contexts/GlobalContext';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import useGuiTranslations from './useGuiTranslations';
import { capitalizeFirstLetter } from '../../Util/StringFunctions';


export default function DefaultLanguageSelector(props) {
    const globalContext = useContext(GlobalContext);
    const [translateGui] = useGuiTranslations();
    const classes = useStyles();
    const languages = [
        { code: 'en', name: 'English' },
        { code: 'de', name: 'Deutsch' },
        { code: 'fr', name: 'Français' },
        { code: 'es', name: 'Español' },
        { code: 'zh', name: '中文' },
        { code: 'ru', name: 'Русский' },
        { code: 'ja', name: '日本語' },
        { code: 'it', name: 'İtaliano' },
        { code: 'sv', name: 'Svenska' },
        { code: 'tr', name: 'Türkçe' },
    ];


    return (
        <FormControl className={classes.formControl}>
            <InputLabel id="language-label">{capitalizeFirstLetter(translateGui(62))}</InputLabel>
            {

                <Select
                    labelId="language-label"
                    id="language-select"
                    value={props.language}
                    onChange={(e) => props.setLanguage(e.target.value)}
                >
                    {
                        languages.map(
                            (lang, index) =>
                                <MenuItem key={lang.code} value={lang.code}>{lang.name}</MenuItem>
                        )
                    }

                </Select>

            }

        </FormControl>

    )
}

const useStyles = makeStyles({
    root: {
    }
});